// Frontend mirror of backend/utils/couple.py — must stay in lock-step so
// what the couple sees on the RSVP page & dashboard preview matches what
// guests receive over email/SMS.
export function coupleNames(profile, fallback = 'The couple') {
  if (!profile) return fallback;
  const p1 = (profile.partner1 || '').trim();
  const p2 = (profile.partner2 || '').trim();
  const order = (profile.nameOrder || 'partner1_first').toLowerCase();
  const names = order === 'partner2_first' ? [p2, p1] : [p1, p2];
  const joined = names.filter(Boolean).join(' and ');
  return joined || fallback;
}
